module.exports = __webpack_public_path__ + "static/series_750-ca75e011c2d37d31b520c0f3c8834b51.png";